import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ToolIcon = ({ tool }) => {
  return (
    <div
      className="tool-tile aspect-square flex items-center justify-center rounded-[10px] font-serif-display"
      style={{ backgroundColor: tool.color, color: tool.text }}
    >
      {tool.isMidjourney ? (
        <svg
          viewBox="0 0 24 24"
          width="28"
          height="28"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M3 18c3-8 8-12 12-13 0 0-1 5-4 9s-8 4-8 4z" />
          <path d="M8 16c2-5 5-8 8-9" />
        </svg>
      ) : tool.isGpt ? (
        <svg
          viewBox="0 0 24 24"
          width="26"
          height="26"
          fill="currentColor"
        >
          <path d="M22 10a5 5 0 0 0-.7-2.5A5 5 0 0 0 16 3a5 5 0 0 0-4 2 5 5 0 0 0-6.3 6.5A5 5 0 0 0 8 20a5 5 0 0 0 4-2 5 5 0 0 0 6.3-6.5A5 5 0 0 0 22 10zM12 18.7a3.7 3.7 0 0 1-2.4-.9l.1-.1 4-2.3a.7.7 0 0 0 .3-.5v-5.6l1.7 1v4.7a3.7 3.7 0 0 1-3.7 3.7zM4.6 15.5a3.7 3.7 0 0 1-.4-2.5l.1.1 4 2.3a.7.7 0 0 0 .7 0l4.9-2.8v2l-4.1 2.4a3.7 3.7 0 0 1-5.2-1.5zM3.6 8.4a3.7 3.7 0 0 1 1.9-1.6v4.8a.7.7 0 0 0 .3.6l4.9 2.8-1.7 1-4.1-2.4a3.7 3.7 0 0 1-1.3-5.2zm13.3 3.1L11.9 8.7l1.7-1L17.7 10a3.7 3.7 0 0 1-.8 6.6v-4.7a.7.7 0 0 0-.3-.6zm1.7-2.5l-.1-.1-4-2.3a.7.7 0 0 0-.7 0L8.9 9.4v-2l4.1-2.4a3.7 3.7 0 0 1 5.6 3.9zM8 10.6l-1.7-1V5a3.7 3.7 0 0 1 6.1-2.8l-.1.1-4 2.3a.7.7 0 0 0-.3.6zm.9-2l2.2-1.3 2.2 1.3v2.5L11 12.4 8.8 11z" />
        </svg>
      ) : (
        <img
          src={tool.icon}
          alt={tool.name}
          className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
        />
      )}
    </div>
  );
};

const CategoryGrid = ({ categories, tools }) => {
  return (
    <section
      id="projects"
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-6 py-10 border-b-2 divider-line"
    >
      {categories.map((cat, idx) => (
        <div
          key={idx}
          className="
            col-span-1
            sm:col-span-1
            lg:col-span-3
            category-card
            border-b sm:border-b-0 lg:border-r
            divider-line
            last:border-r-0
            pb-8 sm:pb-0
            lg:pr-6
          "
        >
          <p className="text-center text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui font-medium text-[#0f0f0f]">
            {cat.title}
          </p>

          <div className="relative w-full h-[260px] sm:h-[240px] lg:h-[210px] mt-4 overflow-hidden bg-[#e8e2d3]">
            <img
              src={cat.image}
              alt={cat.title}
              className="category-image w-full h-full object-cover"
            />
          </div>

          <p className="font-serif-body text-[15px] text-center text-[#2a2a2a] mt-4 leading-snug whitespace-pre-line">
            {cat.subtitle}
          </p>

          <Link
            to={`/${cat.slug}`}
            onClick={() =>
              window.scrollTo({
                top: 0,
                behavior: 'auto',
              })
            }
            className="link-underline mt-4 inline-flex items-center gap-2 text-[10px] tracking-[0.28em] font-sans-ui font-medium text-[#0f0f0f]"
          >
            {cat.link}
            <ArrowRight size={12} />
          </Link>
        </div>
      ))}

      {/* Tools */}
      <div
        id="tools"
        className="
          col-span-1
          sm:col-span-2
          lg:col-span-3
          lg:pl-2
          pt-2 sm:pt-6 lg:pt-0
        "
      >
        <p className="text-center text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui font-medium text-[#0f0f0f]">
          {tools.title}
        </p>

        <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-3 gap-2.5 mt-4 max-w-[280px] sm:max-w-[360px] lg:max-w-none mx-auto">
          {tools.items.map((t, i) => (
            <ToolIcon key={i} tool={t} />
          ))}
        </div>

        <p className="font-serif-body text-[15px] text-center text-[#2a2a2a] mt-4 leading-snug whitespace-pre-line max-w-[280px] mx-auto">
          {tools.subtitle}
        </p>
      </div>
    </section>
  );
};

export default CategoryGrid;
